///// Component /////
class $144531c0d2cfe5fe$export$16fa2f45be04daa8 {
    constructor(payload = {}){
        const { tagName: tagName = "div", props: props = {}, state: state = {} } = payload;
        this.el = document.createElement(tagName) // 컴포넌트의 최상위 요소
        ;
        this.props = props // 컴포넌트가 사용될 때 부모 컴포넌트에서 받는 데이터
        ;
        this.state = state // 컴포넌트 안에서 사용할 데이터
        ;
        this.render();
    }
    render() {
    // 컴포넌트를 렌더링하는 함수
    // ...
    }
}
// 페이지 렌더링!
function $144531c0d2cfe5fe$var$routeRender(routes) {
    // 접속할 때 해시 모드가 아니면(해시가 없으면) /#/로 리다이렉트!
    if (!location.hash) history.replaceState(null, "", "/#/") // (상태, 제목, 주소)
    ;
    const routerView = document.querySelector("router-view");
    const [hash, queryString = ""] = location.hash.split("?") // 물음표를 기준으로 해시 정보와 쿼리스트링을 구분
    ;
    const query = queryString.split("&").reduce((acc, cur)=>{
        const [key, value] = cur.split("=");
        acc[key] = value;
        return acc;
    }, {});
    history.replaceState(query, "") // (상태, 제목)
    ;
    // 2) 현재 라우트 정보를 찾아서 렌더링!
    const currentRoute = routes.find((route)=>new RegExp(`${route.path}/?$`).test(hash));
    if (routerView) {
        routerView.innerHTML = "";
        currentRoute && routerView.append(new currentRoute.component().el);
    }
    // 3) 화면 출력 후 스크롤 위치 복구!
    window.scrollTo(0, 0);
}
function $144531c0d2cfe5fe$export$baddd0131ee8c05b(routes) {
    // 원하는(필요한) 곳에서 호출할 수 있도록 함수 데이터를 반환!
    return function() {
        window.addEventListener("popstate", ()=>{
            $144531c0d2cfe5fe$var$routeRender(routes);
        });
        $144531c0d2cfe5fe$var$routeRender(routes);
    };
}
class $144531c0d2cfe5fe$export$390f32400eaf98c9 {
    constructor(state){
        this.state = {} // 상태(데이터)
        ;
        this.observers = {};
        for(const key in state)// 각 상태에 대한 변경 감시(Setter) 설정!
        Object.defineProperty(this.state, key, {
            // Getter
            get: ()=>state[key],
            // Setter
            set: (val)=>{
                state[key] = val;
                if (Array.isArray(this.observers[key])) // 호출할 콜백이 있는 경우!
                this.observers[key].forEach((observer)=>observer(val));
            }
        });
    }
    // 상태 변경 구독!
    subscribe(key, cb) {
        Array.isArray(this.observers[key]) // 이미 등록된 콜백이 있는지 확인!
         ? this.observers[key].push(cb) // 있으면 새로운 콜백 밀어넣기!
         : this.observers[key] = [
            cb
        ] // 없으면 콜백 배열로 할당!
        ;
    // 예시)
    // observers = {
    //   구독할상태이름: [실행할콜백1, 실행할콜백2]
    //   movies: [cb, cb, cb],
    //   message: [cb]
    // }
    }
}



class $6488ad9fef577b9d$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "header",
            state: {
                menus: [
                    {
                        name: "Search",
                        href: "#/"
                    },
                    {
                        name: "Movie",
                        href: "#/movie?id=tt4520988"
                    },
                    {
                        name: "About",
                        href: "#/about"
                    }
                ]
            }
        });
        window.addEventListener("popstate", ()=>{
            this.render();
        });
    }
    render() {
        this.el.innerHTML = /* html */ `
      <a 
        href="#/" 
        class="logo">
        <span>OMDbAPI</span>.COM
      </a>
      <nav>
        <ul>
          ${this.state.menus.map((menu)=>{
            const href = menu.href.split("?")[0];
            const hash = location.hash.split("?")[0];
            const isActive = href === hash;
            return /* html */ `
              <li>
                <a
                  class="${isActive ? "active" : ""}" 
                  href="${menu.href}">
                  ${menu.name}
                </a>
              </li>
            `;
        }).join("")}
        </ul>
      </nav>
      <a href="#/about" class="user">
        <img src="https://velog.velcdn.com/images/flamozzi/profile/25a35fbc-f5f4-4fc0-ad83-10ce51a69267/image.png" alt="User"/>
      </a>
    `;
    }
}




var $9f00f93a4d28fd0f$export$2e2bcd8739ae039 = new (0, $144531c0d2cfe5fe$export$390f32400eaf98c9)({
    photo: "https://velog.velcdn.com/images/flamozzi/profile/25a35fbc-f5f4-4fc0-ad83-10ce51a69267/image.png",
    name: "flamozzi / ParkJiSung",
    email: "pjs99047@gmail.com",
    blog: "https://velog.io/@flamozzi",
    github: "https://github.com/flamozzi",
    repository: "https://github.com/flamozzi/movie-search-app"
});


class $af4f8136ffd7faf7$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "footer"
        });
    }
    render() {
        const { github: github, repository: repository } = (0, $9f00f93a4d28fd0f$export$2e2bcd8739ae039).state;
        this.el.innerHTML = /* html */ `
      <div>
        <a href="${repository}">
          Github Repository
        </a>
      </div>
      <div>
        <a href="${github}">
          ${new Date().getFullYear()}
          flamozzi
        </a>
      </div>
    `;
    }
}


class $2ae89aad8d89d959$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    render() {
        const theHeader = new (0, $6488ad9fef577b9d$export$2e2bcd8739ae039)().el;
        const theFooter = new (0, $af4f8136ffd7faf7$export$2e2bcd8739ae039)().el;
        const routerView = document.createElement("router-view");
        // prettier-ignore
        this.el.append(theHeader, routerView, theFooter);
    }
}





class $1bf7e69fb47f344b$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("headline");
        this.el.innerHTML = /* html */ `
      <h1>
        <span>OMDb API</span><br>
        THE OPEN<br>
        MOVIE DATABASE
      </h1>
      <p>
      The OMDb API is a RESTful web service to obtain movie information, 
      all content and images on the site are contributed and maintained by our users. <br>
      If you find this service useful, please consider making a one-time donation or become a patron.
      </p>
    `;
    }
}




const $6519604fa6fd3eb8$var$store = new (0, $144531c0d2cfe5fe$export$390f32400eaf98c9)({
    searchText: "",
    page: 1,
    pageMax: 1,
    movies: [],
    movie: {},
    loading: false,
    message: "Search for the movie title!"
});
var $6519604fa6fd3eb8$export$2e2bcd8739ae039 = $6519604fa6fd3eb8$var$store;
const $6519604fa6fd3eb8$export$b0c4d3ac9887d994 = async (page)=>{
    $6519604fa6fd3eb8$var$store.state.loading = true;
    $6519604fa6fd3eb8$var$store.state.page = page;
    if (page === 1) {
        $6519604fa6fd3eb8$var$store.state.movies = [];
        $6519604fa6fd3eb8$var$store.state.message = "";
    }
    try {
        const res = await fetch("/api/movie", {
            method: "POST",
            body: JSON.stringify({
                title: $6519604fa6fd3eb8$var$store.state.searchText,
                page: page
            })
        });
        const { Search: Search, totalResults: totalResults, Response: Response, Error: Error } = await res.json();
        if (Response === "True") {
            // prettier-ignore
            $6519604fa6fd3eb8$var$store.state.movies = [
                ...$6519604fa6fd3eb8$var$store.state.movies,
                ...Search
            ];
            $6519604fa6fd3eb8$var$store.state.pageMax = Math.ceil(Number(totalResults) / 10);
        } else {
            $6519604fa6fd3eb8$var$store.state.message = Error;
            // 추가 페이지 상태(pageMax)값이 2 이상일 때 영화 목록을 가져올 수 없는 상황이 되면 상태를 초기화 하는 코드
            $6519604fa6fd3eb8$var$store.state.pageMax = 1;
        }
    } catch (error) {
        console.log("searchMovies error:", error);
    } finally{
        $6519604fa6fd3eb8$var$store.state.loading = false;
    }
};
const $6519604fa6fd3eb8$export$e7daf9f9f7371f9a = async (id)=>{
    try {
        const res = await fetch("/api/movie", {
            method: "POST",
            body: JSON.stringify({
                id: id
            })
        });
        $6519604fa6fd3eb8$var$store.state.movie = await res.json();
    } catch (error) {
        console.log("getMovieDetails error:", error);
    }
};


class $20431fda5c575689$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("search");
        this.el.innerHTML = /* html */ `
      <input 
        value="${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText}"
        placeholder="Enter the movie title to search!" />
      <button class="btn btn-primary">
        Search!
      </button>
    `;
        const inputEl = this.el.querySelector("input");
        inputEl?.addEventListener("input", ()=>{
            (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText = inputEl.value;
        });
        inputEl?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter" && (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)(1);
        });
        const btnEl = this.el.querySelector(".btn");
        btnEl?.addEventListener("click", ()=>{
            if ((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)(1);
        });
    }
}





class $1c75024113bbd448$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    constructor(props){
        super({
            props: props,
            tagName: "a"
        });
    }
    render() {
        const { movie: movie } = this.props;
        this.el.setAttribute("href", `#/movie?id=${movie.imdbID}`);
        this.el.classList.add("movie");
        this.el.style.backgroundImage = `url(${movie.Poster})`;
        this.el.innerHTML = /* html */ `
      <div class="info">
        <div class='year'>
          ${movie.Year}
        </div>
        <div class='title'>
          ${movie.Title}
        </div>
      </div>
    `;
    }
}


class $7a11c170c3fb4054$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    constructor(){
        super();
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("movies", ()=>{
            this.render();
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("loading", ()=>{
            this.render();
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("message", ()=>{
            this.render();
        });
    }
    render() {
        this.el.classList.add("movie-list");
        this.el.innerHTML = /* html */ `
      ${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.message ? `<div class="message">${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.message}</div>` : `<div class="movies"></div>`}
      <div class="the-loader hide"></div>
    `;
        const moviesEl = this.el.querySelector(".movies");
        moviesEl?.append(...(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.movies.map((movie)=>new (0, $1c75024113bbd448$export$2e2bcd8739ae039)({
                movie: movie
            }).el));
        const loaderEl = this.el.querySelector(".the-loader");
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.loading ? loaderEl?.classList.remove("hide") : loaderEl?.classList.add("hide");
    }
}




class $3ebe9f9f5c4af79c$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "button"
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("pageMax", ()=>{
            const { page: page, pageMax: pageMax } = (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state;
            pageMax > page ? this.el.classList.remove("hide") : this.el.classList.add("hide");
        });
    }
    render() {
        this.el.classList.add("btn", "view-more", "hide");
        this.el.textContent = "View more..";
        this.el.addEventListener("click", async ()=>{
            this.el.classList.add("hide");
            await (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.page + 1);
        });
    }
}


class $8f966fc6c3ddd7f9$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    render() {
        const headline = new (0, $1bf7e69fb47f344b$export$2e2bcd8739ae039)().el;
        const search = new (0, $20431fda5c575689$export$2e2bcd8739ae039)().el;
        const movieList = new (0, $7a11c170c3fb4054$export$2e2bcd8739ae039)().el;
        const movieListMore = new (0, $3ebe9f9f5c4af79c$export$2e2bcd8739ae039)().el;
        this.el.classList.add("container");
        // prettier-ignore
        this.el.append(headline, search, movieList, movieListMore);
    }
}




class $9e7e61b7f62dc712$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    async render() {
        this.el.classList.add("container", "the-movie");
        this.el.innerHTML = /* html */ `
      <div class="poster skeleton"></div>
      <div class="specs">
        <div class="title skeleton"></div>
        <div class="labels skeleton"></div>
        <div class="plot skeleton"></div>
      </div>
    `;
        await (0, $6519604fa6fd3eb8$export$e7daf9f9f7371f9a)(history.state.id);
        console.log((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.movie);
        const { movie: movie } = (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state;
        const bigPoster = movie.Poster.replace("SX300", "SX700");
        this.el.innerHTML = /* html */ `
      <div
        style="background-image: url(${bigPoster})"
        class="poster">
      </div>
      <div class="specs">
        <div class="title">
          ${movie.Title}
        </div>
        <div class="labels">
          <span>${movie.Released}</span>
          &nbsp;/&nbsp;
          <span>${movie.Runtime}</span>
          &nbsp;/&nbsp;
          <span>${movie.Country}</span>
        </div>
        <div class="plot">
          ${movie.Plot}
        </div>
        <div>
          <h3>Ratings</h3>
          ${movie.Ratings.map((rating)=>{
            return `<p>${rating.Source} - ${rating.Value}</p>`;
        }).join("")}
        </div>
        <div>
          <h3>Actors</h3>
          <p>${movie.Actors}</p>
        </div>
        <div>
          <h3>Director</h3>
          <p>${movie.Director}</p>
        </div>
        <div>
          <h3>Production</h3>
          <p>${movie.Production}</p>
        </div>
        <div>
          <h3>Genre</h3>
          <p>${movie.Genre}</p>
        </div>
      </div>
    `;
    }
}




class $c06da9a08b0e3020$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    render() {
        const { photo: photo, name: name, email: email, github: github, blog: blog } = (0, $9f00f93a4d28fd0f$export$2e2bcd8739ae039).state;
        this.el.classList.add("container", "about");
        this.el.innerHTML = /* html */ `
      <div 
        style="background-image: url(${photo})" 
        class="photo">
      </div>
      <p class="name">${name}</p>
      <p>
        <a 
          href="https://mail.google.com/mail/?view=cm&fs=1&to=${email}" target="_blank">
          ${email}
        </a>
      </p>
      <p><a href="${github}" target="_blank">GitHub</a></p>
      <p><a href="${blog}" target="_blank">Blog</a></p>
    `;
    }
}



class $651330ec7a632937$export$2e2bcd8739ae039 extends (0, $144531c0d2cfe5fe$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("container", "not-found");
        this.el.innerHTML = /* html */ `
      <h1>
        Sorry..<br>
        Page not found.
      </h1>
    `;
    }
}


var $573f2dca97842810$export$2e2bcd8739ae039 = (0, $144531c0d2cfe5fe$export$baddd0131ee8c05b)([
    {
        path: "#/",
        component: (0, $8f966fc6c3ddd7f9$export$2e2bcd8739ae039)
    },
    {
        path: "#/movie",
        component: (0, $9e7e61b7f62dc712$export$2e2bcd8739ae039)
    },
    {
        path: "#/about",
        component: (0, $c06da9a08b0e3020$export$2e2bcd8739ae039)
    },
    {
        path: ".*",
        component: (0, $651330ec7a632937$export$2e2bcd8739ae039)
    }
]);


const $ad2bcec7a0192558$var$root = document.querySelector("#root");
$ad2bcec7a0192558$var$root?.append(new (0, $2ae89aad8d89d959$export$2e2bcd8739ae039)().el);
(0, $573f2dca97842810$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.c71dbf30.js.map
